import { Action } from "@ngrx/store";
import { ReduxAction } from "../redux.action";
import { TestOrderCodeSelectionSession } from "../../models";

export class SetTestOrderCodeSelectionSession implements ReduxAction {
  type: string = "SET_TEST_ORDER_CODE_SELECTION_SESSION";
  codeSelectionSession: TestOrderCodeSelectionSession;

  constructor(testSelectionSession: TestOrderCodeSelectionSession) {
    this.codeSelectionSession = testSelectionSession;
  }

  get() {
    return this.codeSelectionSession;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/test-order/set-test-order-code-selection-session.action.ts